import { DDDNormalResultPresentation } from "../normal/DDDNormalResultPresentation";

export class DDDRespinResultPresentation extends DDDNormalResultPresentation {
    constructor(id: string = `DDDRespinResultPresentation`) {
        super(id);
    }
}
